import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Three-state chip for carrier-week eligibility:
 *   - true   -> Eligible (green)
 *   - false  -> Not eligible (red)
 *   - null   -> Pending evaluation (gray) — used while the Monday cron has
 *              not yet evaluated the current week.
 *
 * Keep this presentational so it is reusable from Overview, Summary card and
 * the Drivers/Bonuses pages.
 */
@Component({
  selector: 'lohi-eligibility-status-chip',
  templateUrl: './eligibility-status-chip.component.html',
  styleUrls: ['./eligibility-status-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EligibilityStatusChipComponent {
  @Input() public eligible: boolean | null = null;
  @Input() public inAllowlist = true;
  @Input() public size: 'sm' | 'md' = 'md';

  public get label(): string {
    if (!this.inAllowlist) {
      return 'Not in program';
    }
    if (this.eligible === true) {
      return 'Eligible';
    }
    if (this.eligible === false) {
      return 'Not eligible';
    }
    return 'Pending';
  }

  public get cssClass(): string {
    const sizeClass = this.size === 'sm' ? 'ppp-chip--sm' : 'ppp-chip--md';
    if (!this.inAllowlist) {
      return `ppp-chip ppp-chip--gray ${sizeClass}`;
    }
    if (this.eligible === true) {
      return `ppp-chip ppp-chip--green ${sizeClass}`;
    }
    if (this.eligible === false) {
      return `ppp-chip ppp-chip--red ${sizeClass}`;
    }
    return `ppp-chip ppp-chip--amber ${sizeClass}`;
  }
}
